import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Typography } from '@mui/material';
import { GridColDef, GridActionsCellItem } from '@mui/x-data-grid-pro';

import { DataGridColSettings } from '@/components/DataGrid/utils';
import { IIncidentCode } from '@/models/incident.code';

interface IncidentCodeMenuHandlerProps {
  onOpenMenu: (
    event: React.MouseEvent<HTMLButtonElement>,
    incidentCode: IIncidentCode,
  ) => void;
}

export const getIncidentCodeDataGridColumns = ({
  onOpenMenu,
}: IncidentCodeMenuHandlerProps): GridColDef<IIncidentCode>[] => [
  {
    field: 'code',
    headerName: 'Incident Code',
    flex: 1,
    minWidth: 150,
    renderCell: (params) => (
      <Typography variant="body2" noWrap sx={{ fontWeight: 'medium' }}>
        {params.value}
      </Typography>
    ),
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 2,
    minWidth: 250,
    renderCell: (params) => (
      <Typography variant="body2" noWrap title={params.value || 'N/A'}>
        {params.value || '-'}
      </Typography>
    ),
  },
  {
    field: 'emergency',
    headerName: 'Auto ready for dispatch',
    flex: 2,
    minWidth: 250,
    renderCell: (params) => (
      <Typography
        variant="body2"
        noWrap
        title={params.value !== false ? 'Yes' : 'No'}
      >
        {params.value !== false ? 'Yes' : 'No'}
      </Typography>
    ),
  },
  {
    field: 'carStopAgencies',
    headerName: 'Used for Car Stop',
    flex: 1,
    minWidth: 160,
    renderCell: (params) => (
      <Typography
        variant="body2"
        noWrap
        title={params.value?.length ? 'Yes' : 'No'}
      >
        {params.value?.length ? 'Yes' : 'No'}
      </Typography>
    ),
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Actions',
    width: 80,
    align: 'center',
    headerAlign: 'center',
    getActions: (params) => [
      <GridActionsCellItem
        key={`menu-${params.row._id}`}
        icon={<MoreHorizIcon />}
        label="Menu"
        onClick={(event) => onOpenMenu(event, params.row)}
        color="primary"
      />,
    ],
  },
];

export const incidentCodeInitialColumnSettings: DataGridColSettings[] = [
  {
    field: 'code',
    headerName: 'Incident Code',
    width: 150,
    visible: true,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 300,
    visible: true,
  },
  {
    field: 'emergency',
    headerName: 'Emergency',
    width: 100,
    visible: true,
  },
  {
    field: 'carStopAgencies',
    headerName: 'Used for Car Stop',
    width: 160,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 80,
    visible: true,
  },
];
